import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../BusComponent';
import IconMenu from '../iconMenu/IconMenu';
import { takeTourButtonEvents } from '../../enums/GoogleTagManagerEvents';
import googleTagManagerEvents from '../../helpers/GoogleTagManagerEventsWrapper';

const TakeTourItem = googleTagManagerEvents('button', takeTourButtonEvents);

class HelpCenterButton extends BusComponent {
    handleKeyPress = (event, action) => {
        if (event.type === 'keypress') {
            if (event.key === ' ' || event.key === 'Enter') {
                // prevent the default action to stop scrolling when space is pressed
                event.preventDefault();
            } else {
                // user did not press space nor enter key, so we should do nothing
                return;
            }
        }
        action();
    };
 
    onTourClick = event => {
        this.handleKeyPress(event, () => {
            this.emit('TOGGLE_MAP_LAYERS_PANEL', { isVisible: false });
            this.emit('HELP_TOUR_START_REQUEST');
            this.emit('CLOSE_DROPDOWN');
        });
    };

    onSendFeedbackClick = event => {
        this.handleKeyPress(event, () => {
            this.emit('FEEDBACK_POPUP_REQUEST');
            this.emit('CLOSE_DROPDOWN');
        });
    };
    
    render() {
        const { isApplicationInViewMode, userInfo, intl } = this.props;

        return (
            <IconMenu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                targetOrigin={{ vertical: 'top', horizontal: 'right' }}
                icon="help"
                iconClassName="material-symbols"
                className="application-header__popup-wrapper"
                tabIndex="0"
                tooltip={intl.formatMessage({ id: 'helpCenter' })}
                triggerClassName="application-header__button icon-dark"
                ariaLabel={intl.formatMessage({ id: 'helpCenter' })}
                marginTop={-5}
                marginLeft={10}
            >
                <div className="material-menu">
                    <TakeTourItem className="material-menu__item" onClick={this.onTourClick}>
                        <FormattedMessage id="header.takeATour" />
                    </TakeTourItem>

                    {!isApplicationInViewMode && userInfo.userId !== -1 && (
                        <div>
                            <button
                                className="material-menu__item"
                                onClick={this.onSendFeedbackClick}
                            >
                                <FormattedMessage id="sendFeedback" />
                            </button>
                        </div>
                    )}
                </div>
            </IconMenu>
        );
    }
}

HelpCenterButton.propTypes = {
    intl: PropTypes.object.isRequired,
    isApplicationInViewMode: PropTypes.bool,
    userInfo: PropTypes.object.isRequired,
};

HelpCenterButton.defaultProps = {
    isApplicationInViewMode: false,
};

export default injectIntl(HelpCenterButton);
